var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectArrayTrait from "../../Decorators/objectArrayTrait";
import objectTrait from "../../Decorators/objectTrait";
import primitiveArrayTrait from "../../Decorators/primitiveArrayTrait";
import primitiveTrait from "../../Decorators/primitiveTrait";
import mixTraits from "../../mixTraits";
import ChartPointOnMapTraits from "../ChartPointOnMapTraits";
import DiscretelyTimeVaryingTraits from "../DiscretelyTimeVaryingTraits";
import ExportableTraits from "../ExportableTraits";
import LayerOrderingTraits from "../LayerOrderingTraits";
import LegendOwnerTraits from "../LegendOwnerTraits";
import OpacityTraits from "../OpacityTraits";
import SplitterTraits from "../SplitterTraits";
import TableColumnTraits from "./ColumnTraits";
import TableStyleTraits from "./StyleTraits";
let TableTraits = (_dec = primitiveTrait({
  name: "Show Warning for Unmatched Regions",
  description: "True to show a warning when some of the region IDs in the CSV file could not be matched to a region. False to silently ignore unmatched regions.",
  type: "boolean"
}), _dec2 = objectArrayTrait({
  name: "Columns",
  description: "Options for individual columns/variables.",
  type: TableColumnTraits,
  idProperty: "name"
}), _dec3 = objectTrait({
  name: "Default Column",
  description: "The default settings to use for all columns/variables",
  type: TableColumnTraits
}), _dec4 = objectArrayTrait({
  name: "Styles",
  description: "The set of styles that can be used to visualize this dataset.",
  type: TableStyleTraits,
  idProperty: "id"
}), _dec5 = objectTrait({
  name: "Default Style",
  description: "The default style to apply when visualizing any column/variable.",
  type: TableStyleTraits
}), _dec6 = primitiveTrait({
  name: "Selected Style",
  description: "The ID of the currently-selected style.",
  type: "string"
}), _dec7 = primitiveTrait({
  name: "Enable manual region mapping",
  description: "If enabled, there will be controls to set region column/variable and region type.",
  type: "boolean"
}), _dec8 = primitiveTrait({
  name: "Show disable styling option",
  description: "If enabled, there will be an option in styleDimension to disable styling.",
  type: "boolean"
}), _dec9 = primitiveTrait({
  name: "Show disable time",
  description: "If enabled, there will be an checkbox to disable time.",
  type: "boolean"
}), _dec0 = primitiveArrayTrait({
  name: "Column titles",
  description: "An optional array of column/variable titles that override the individual `TableColumnTraits.title` setting.",
  type: "string"
}), _dec1 = primitiveArrayTrait({
  name: "Column units",
  description: "An optional array of column/variable units that override the individual `TableColumnTraits.unit` setting.",
  type: "string"
}), _dec10 = primitiveTrait({
  name: "Remove duplicate rows",
  type: "boolean",
  description: "If two rows in the table are identical, only retain one copy. This could cause performance issues, and so should be used only when absolutely necessary."
}), _class = class TableTraits extends mixTraits(DiscretelyTimeVaryingTraits, ExportableTraits, LayerOrderingTraits, OpacityTraits, SplitterTraits, ChartPointOnMapTraits, LegendOwnerTraits) {
  constructor() {
    super(...arguments);
    // Not implemented in v8
    _initializerDefineProperty(this, "showUnmatchedRegionsWarning", _descriptor, this);
    _initializerDefineProperty(this, "columns", _descriptor2, this);
    _initializerDefineProperty(this, "defaultColumn", _descriptor3, this);
    _initializerDefineProperty(this, "styles", _descriptor4, this);
    _initializerDefineProperty(this, "defaultStyle", _descriptor5, this);
    _initializerDefineProperty(this, "activeStyle", _descriptor6, this);
    _initializerDefineProperty(this, "enableManualRegionMapping", _descriptor7, this);
    _initializerDefineProperty(this, "showDisableStyleOption", _descriptor8, this);
    _initializerDefineProperty(this, "showDisableTimeOption", _descriptor9, this);
    _initializerDefineProperty(this, "columnTitles", _descriptor0, this);
    _initializerDefineProperty(this, "columnUnits", _descriptor1, this);
    _initializerDefineProperty(this, "removeDuplicateRows", _descriptor10, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "showUnmatchedRegionsWarning", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "columns", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "defaultColumn", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "styles", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "defaultStyle", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "activeStyle", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "enableManualRegionMapping", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "showDisableStyleOption", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "showDisableTimeOption", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "columnTitles", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "columnUnits", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "removeDuplicateRows", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
export { TableTraits as default };